import React, { useState, useEffect } from 'react'
import {TextField, Select, MenuItem, FormControl, InputLabel, Dialog, DialogContent, DialogTitle, Box, DialogActions, IconButton, Stack, Button, Divider  } from '@mui/material';
import { IoSettingsOutline } from "react-icons/io5";
import {UnitTypes, ResolutionTypes, BackgroundMusicTypes, AudioZoneTypes, PrimaryZoneTypes} from './types';

const settingKeys = ["Unit Type", "Resolution", "Background Music", "Audio Zone", "Primary Zone"]
const settingTypes = [UnitTypes, ResolutionTypes, BackgroundMusicTypes, AudioZoneTypes, PrimaryZoneTypes]

const DialogBoxSettings = ({screenInfo, setScreenInfo, settingsInfo, setSettingsInfo, isOpen, onClose}) => {

    const [customs, setCustoms] = useState({width: 0, height: 0});

    // ---- Functions ----
    const changeSettings = (key,val)=>{
        setSettingsInfo(prevSettings => {
            return {...prevSettings, [key]: val}
        })
        console.log("Settings changed")
    }

    const handleCloseDialog = () =>{
        onClose(false)
        setScreenInfo({...screenInfo, customWidth: customs.width, customHeight: customs.height})
    }

    useEffect(()=>{
        setCustoms({width: screenInfo.customWidth, height: screenInfo.customHeight})
    },[])

  return (
    <Dialog
        open={isOpen}
        onClose={() => handleCloseDialog()}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{marginBottom:"10px"}}>
            <Stack direction={"column"} sx={{alignItems:"center"}}>
                <IconButton>
                    <IoSettingsOutline size={"40px"}/>
                </IconButton>
                <Box fontSize="h4.fontSize">Split Screen Configuration</Box>
            </Stack>
        </DialogTitle>
        <DialogContent sx={{}}>
            <Stack direction={"column"} sx={{paddingLeft:"30px", paddingRight:"30px"}}>
            {settingKeys.map((key, index) => (
                <>
                    {key=="Resolution" && settingsInfo["Resolution"]=="Custom" ? 
                    <>
                        <FormControl fullWidth variant="outlined" sx={{marginTop:"20px"}} key={index}>
                            <InputLabel id="select-label">{key}</InputLabel>
                            <Select
                                labelId="select-label"
                                value={settingsInfo[key]}
                                onChange={(e)=>changeSettings(key, e.target.value)}
                                label={key}
                                >
                                {Object.entries(settingTypes[index]).map(([key, value]) => (
                                    <MenuItem key={key} value={value}>
                                        {value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Stack direction="row" sx={{marginTop:"20px", gap:"10px"}}>
                            <TextField
                                label="Width (px)"
                                variant="outlined"
                                value={(customs.width)}
                                onChange={(e)=>setCustoms({...customs, width: e.target.value})}
                                sx={{width:"50%"}}
                            />
                            <TextField
                                label="Height (px)"
                                variant="outlined"
                                value={(customs.height)}
                                onChange={(e)=>setCustoms({...customs, height: e.target.value})}
                                sx={{width:"50%"}}
                            />
                        </Stack>
                    </>
             
                    :
                    <FormControl fullWidth variant="outlined" sx={{marginTop:"20px"}} key={index}>
                        <InputLabel id="select-label">{key}</InputLabel>
                        <Select
                            labelId="select-label"
                            value={settingsInfo[key]}
                            onChange={(e)=>changeSettings(key, e.target.value)}
                            label={key}
                            >
                            {Object.entries(settingTypes[index]).map(([key, value]) => (
                                <MenuItem key={key} value={value}>
                                    {value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    }
                </>
            ))}
            </Stack>
        </DialogContent>

        <Divider sx={{ width: '100%', marginTop:"35px" }} />
        <DialogActions sx={{ backgroundColor: "#1A2432", width: "100%", padding:"10px" }}>
            <Button onClick={() => handleCloseDialog()} color="primary" variant="contained">
                Close
            </Button>
        </DialogActions>
    </Dialog>
  )
}

export default DialogBoxSettings